import React from 'react';
import { useModal } from 'flow/contexts/ModalProvider';
import TicketOverviewPopover from './OverviewPopover/TicketOverviewPopover';
import { TicketKey } from 'flow/types/EntityKeys';

interface Props {
    ticketKey?: TicketKey;
    segmentContext?: string;
}

const TicketOverviewModal = ({ ticketKey, segmentContext }: Props) => {
    const { closeModal } = useModal();
    return (
        <TicketOverviewPopover
            onClose={closeModal}
            ticketKey={ticketKey}
            segmentContext={segmentContext}
        />
    );
};

export default TicketOverviewModal;
